<template>
  <div v-if="routeShow(item)">
    <div>{{routeShow(item)}}</div>
    <template v-if="routeSchema(item)">
      <v-list-item color="primary" :to="{ name: item.name }">
        <v-list-item-icon>
          <v-icon>{{ item.meta.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ item.meta.title }}
        </v-list-item-title>
      </v-list-item>
    </template>

    <template v-else-if="Array.isArray(item.children)">
      <ListGroup :item="item"/>
    </template>

  </div>

</template>

<script>
export default {
  props: {
    item: Object
  },
  components: {
    ListGroup: () => import('@/components/pageUnits/ListGroup')
  }
}
</script>